import { Injectable } from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

// This is needed to use the fonts
(pdfMake as any).vfs = (pdfFonts as any).pdfMake.vfs;
@Injectable({
  providedIn: 'root'
})
export class PdfMakeService {

  constructor() { }

  async generatePdf(data, logo: string) {
    console.log(data);
    console.log(data?.photos);
    const documentDefinition = await this.getDocumentDefinition(data, logo);
    pdfMake.createPdf(documentDefinition).open();
  }
  formatDate(date: string) {
    return new Date(date)?.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: '2-digit'
    })
  }
  async getDocumentDefinition(dataArray: any[], logo: string) {
   try{
    console.log(dataArray, 'data')
    const allContent: any[] = [];
    const imageBase64logo = `${await this.getBase64ImageFromUrl(logo)}?v=${new Date().getTime()}`;

    allContent.push({
      columns: [
        {
          image: imageBase64logo,
          width: 120,
          margin: [0, 0, 0, 40]
        },
        {
          stack: [
            { text: 'Printed On', bold: true, style: 'font11' },
            {
              text: `${new Date().toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
              })}`, style: 'font11'
            }
          ], alignment: 'right'
        }

      ]
    });
    allContent.push({
      text: `${dataArray?.length > 1 ? 'Daily Logs List' : 'Daily Log'}`, bold: true, style: 'font17', margin: [0, 0, 0, 0]
    })
    allContent.push({
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 515,
          y2: 0,
          lineWidth: 1,
          lineColor: '#cccccc'
        }
      ],
      margin: [0, 10, 0, 10]
    });
    for (let index = 0; index < dataArray.length; index++) {
      const data = dataArray[index];
      let arr1 = [];
      let arr2 = [];
      let arr3 = [];
      let arr4 = [];
      let attchUrls: string[] = [];
      if (dataArray?.length > 0) {

        console.log(data?.photos)
        for (let photo of data?.photos || []) {
          attchUrls.push(await this.getBase64ImageFromUrl(`${photo?.file_path}?v=${new Date().getTime()}`));
          console.log(attchUrls)
        }
        console.log(attchUrls)
        const paddedImages = (arr: string[]) => {
          while (arr.length < 3) arr.push(null);
          return arr;
        };

        arr1 = paddedImages(attchUrls.slice(0, 3));
        arr2 = paddedImages(attchUrls.slice(3, 6));
        arr3 = paddedImages(attchUrls.slice(6, 9));
        arr4 = paddedImages(attchUrls.slice(9, 12));
      }
      const formattedDate = new Date(data?.created_at).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
      });
      const contentArr: any[] = [
        // {
        //   stack: [
        //     // { text: 'Log Title', bold: true, style: 'font11' },
        //     { text: this.formatDate(data?.created_at), style: 'font16', bold: true,margin:[0,0,0,10] }
        //   ]
        // },
        {
          columns: [
            {
              text: this.formatDate(data?.created_at),
              style: 'font16',
              bold: true,
              margin: [0, 0, 0, 10]
            },
            {
              stack: [
              {
                stack:[
                { text: 'Created by', bold: true, style: 'font11' },
                { text: this.toTitleCase(data?.created_by_name), style: 'font10' }
              ],margin:[0,0,0,10]},
              {stack:[
                { text: data?.date_related?'Daily log relates to':'', bold: true, style: 'font11' },
                { text: data?.date_related?this.formatDate(data?.date_related):'', style: 'font10' }
              ]},
              ],
              alignment: 'right',
              margin: [0, 0, 0, 0]
            }
          ]
        },
        {
          stack: [
            { text: 'Log Title', bold: true, style: 'font11' },
            { text: this.toTitleCase(data?.log_title), style: 'font10' }
          ]
        },
        // {
        //   stack: [
        //     { text: 'Created by', bold: true, style: 'font11' },
        //     { text: this.toTitleCase(data?.customerDataForPdf?.name), style: 'font11' }
        //   ], margin: [0, 10, 0, 10]
        // },
        {
          stack: [
            { text: 'Description', bold: true, style: 'font11' },
            { text: this.toTitleCase(data?.log_description), style: 'font10' }
          ], margin: [0, 10, 0, 0]
        }
      ];



      // if (data?.weatherDetails) {
      //   contentArr.push(
      //     {
      //       stack: [
      //         { text: 'Weather Conditions', bold: true, style: 'font11' },
      //         { text: this.toTitleCase(data?.weatherDetails[0]?.weather_details?.weather_desc || '---'), style: 'font11' }
      //       ], margin: [0, 10, 0, 10]
      //     }
      //   );
      // }

      // if (data?.weatherDetails?.length > 0) {
      //   contentArr.push({
      //     columns: [
      //       {
      //         table: {
      //           body: [[
      //             {
      //               image: await this.getBase64ImageFromUrl(`http://openweathermap.org/img/wn/${data?.weatherDetails[0]?.icon}@2x.png`),
      //               width: 50,
      //             },
      //             {
      //               margin: [0, 5, 0, 0],
      //               stack: [
      //                 { text: `${data?.weatherDetails[0]?.temp}°C`, style: 'font11', bold: true },
      //                 { text: `${data?.weatherDetails[0]?.weather_details?.feel_like_temp || ''}°C`, style: 'font11' }
      //               ]
      //             },
      //             {
      //               margin: [0, 10, 0, 0],
      //               table: {
      //                 body: [[
      //                   {
      //                     image: await this.getBase64ImageFromUrl('../../../assets/images/location.svg'),
      //                     width: 10
      //                   },
      //                   { text: data?.weatherDetails[0]?.location, style: 'font9' }
      //                 ]]
      //               },
      //               layout: 'noBorders'
      //             },
      //             {
      //               margin: [0, 10, 0, 0],
      //               table: {
      //                 body: [[
      //                   {
      //                     image: await this.getBase64ImageFromUrl('../../../assets/images/wind-speed.svg'),
      //                     width: 10
      //                   },
      //                   { text: data?.weatherDetails[0]?.weather_details?.wind_speed, style: 'font9' }
      //                 ]]
      //               },
      //               layout: 'noBorders'
      //             },
      //             {
      //               margin: [0, 10, 0, 0],
      //               table: {
      //                 body: [[
      //                   {
      //                     image: await this.getBase64ImageFromUrl('../../../assets/images/humidity.svg'),
      //                     width: 10
      //                   },
      //                   { text: data?.weatherDetails[0]?.weather_details?.humidity, style: 'font9' }
      //                 ]]
      //               },
      //               layout: 'noBorders'
      //             }
      //           ]]
      //         },
      //         layout: 'noBorders',
      //         width: '100%'
      //       }
      //     ],
      //     margin: [0, 0, 0, 0]
      //   });
      // }

      if (data?.weatherDetails?.length > 0) {
        const weather = data.weatherDetails[0];

        // contentArr.push({
        //   columns: [
        //     {
        //       stack: [
        //         { text: 'Weather Conditions', bold: true, style: 'font11' },
        //         { text: this.toTitleCase(weather?.weather_details?.weather_desc || '---'), style: 'font11' }
        //       ],
        //       width: 150,
        //       margin: [0, 10, 10, 0]
        //     },
        //     {
        //       image: await this.getBase64ImageFromUrl(`http://openweathermap.org/img/wn/${weather?.icon}@2x.png`),
        //       width: 50,
        //       margin: [0, 0, 10, 0]
        //     },
        //     {
        //       stack: [
        //         { text: `${weather?.temp}°C`, style: 'font11', bold: true },
        //         { text: `${weather?.weather_details?.feel_like_temp || ''}°C`, style: 'font11' }
        //       ],
        //       margin: [0, 5, 10, 0]
        //     },
        //     {
        //       columns: [
        //         {
        //           image: await this.getBase64ImageFromUrl('../../../assets/images/location.svg'),
        //           width: 10,
        //           margin: [0, 2, 5, 0]
        //         },
        //         { text: weather?.location, style: 'font9' }
        //       ],
        //       margin: [0, 10, 10, 0]
        //     },
        //     {
        //       columns: [
        //         {
        //           image: await this.getBase64ImageFromUrl('../../../assets/images/wind-speed.svg'),
        //           width: 10,
        //           margin: [0, 2, 5, 0]
        //         },
        //         { text: weather?.weather_details?.wind_speed, style: 'font9' }
        //       ],
        //       margin: [0, 10, 10, 0]
        //     },
        //     {
        //       columns: [
        //         {
        //           image: await this.getBase64ImageFromUrl('../../../assets/images/humidity.svg'),
        //           width: 10,
        //           margin: [0, 2, 5, 0]
        //         },
        //         { text: weather?.weather_details?.humidity, style: 'font9' }
        //       ],
        //       margin: [0, 10, 0, 0]
        //     }
        //   ],
        //   margin: [0, 0, 0, 10]
        // });

        // First line: Weather Conditions
        contentArr.push({
          columns: [
            {
              stack: [
                { text: 'Weather Conditions', bold: true, style: 'font11' },
                { text: this.toTitleCase(weather?.weather_details?.weather_desc || '---'), style: 'font11' }
              ],
              width: 'auto',
              margin: [0, 10, 10, 0]
            },
            {
                image: await this.getBase64ImageFromUrl(`http://openweathermap.org/img/wn/${weather?.icon}@2x.png`),
                width: 50,
                margin: [0, 0, 5, 0]
              },
              (weather?.temp || weather?.weather_details?.feel_like_temp)?({
                stack: [
                  weather?.temp?{ text: `${weather?.temp || ''}°C`, style: 'font11', bold: true, width:30}:'',
                  weather?.weather_details?.feel_like_temp?{ text: `${weather?.weather_details?.feel_like_temp || ''}°C`, style: 'font10', margin: [0, 3, 0, 0],width:30 }:''
                ],
                width:'auto',
                margin: [0, 10, 20, 0]
              }):{text:'',width:0},
              {
                stack: [
                  {
                    columns: [
                      {
                        image: await this.getBase64ImageFromUrl('../../../assets/images/location.svg'),
                        width: 10,
                        margin: [0, 0, 5, 0]
                      },
                      { text: weather?.location, style: 'font9', margin: [2, 0, 0, 0] }
                    ],
                    margin: [0, 2, 0, 0]
                  },
                  weather?.weather_details?.wind_speed?({
                    columns: [
                      {
                        image: await this.getBase64ImageFromUrl('../../../assets/images/wind-speed.svg'),
                        width: 10,
                        margin: [0, 0, 5, 0]
                      },
                      { text: `${weather?.weather_details?.wind_speed || ''}mph`, style: 'font9', margin: [2, 0, 0, 0] }
                    ],
                    margin: [0, 2, 0, 0]
                  }):'',
                  weather?.weather_details?.humidity?({
                    columns: [
                      {
                        image: await this.getBase64ImageFromUrl('../../../assets/images/humidity.svg'),
                        width: 10,
                        margin: [0, 0, 5, 0]
                      },
                      { text: `${weather?.weather_details?.humidity || ''}%`, style: 'font9', margin: [2, 0, 0, 0] }
                    ],
                    margin: [0, 2, 0, 0]
                  }):{text:'',width:0}
                ],
                margin: [0, 11, 0, 0]
              }
          ],
        })
      }

      if (attchUrls.length > 0) {
        contentArr.push({ text: "Attachments", alignment: 'left', fontSize: 11, bold: true });

        const addImageRows = (arr: any[]) => {
          contentArr.push({
            columns: arr.map((url, index) => ({
              stack: [
                url
                  ? { image: url, width: 100, margin: [index == 0 ? 0 : 0, 10, 0, 0] }
                  : { text: '', width: 100, margin: [index == 0 ? 0 : 0, 10, 0, 0] }
              ]
            }))
          });
        };

        [arr1, arr2, arr3, arr4].forEach((arr) => {
          if (arr.some(Boolean)) addImageRows(arr); // only if any image exists
        });
      }

      // Add horizontal divider after each section (except last)
      if (index !== dataArray.length - 1) {
        contentArr.push({
          canvas: [
            {
              type: 'line',
              x1: 0,
              y1: 0,
              x2: 515,
              y2: 0,
              lineWidth: 1,
              lineColor: '#cccccc'
            }
          ],
          margin: [0, 5, 0, 10]
        });
      }
      if (data?.comments?.length > 0) {
        const commentStack = [
          { text: 'Comments', bold: true, style: 'font11' }
        ];

        data.comments.forEach((item: any) => {
          commentStack.push({
            text: '- ' + this.toTitleCase(item?.comment || '---'),
            style: 'font11',
            bold: false,
            margin: [0, 5, 0, 0]
          } as any,
            {
              text: 'Commented By - ' + item?.commenter_name || '',
              alignment: 'right',
              color: '#888888',
              fontSize: 9,
              margin: [0, 0, 0, 5]
            } as any);
        });


        contentArr.push({
          columns: [
            {
              stack: commentStack,
              margin: [0, 10, 10, 0]
            }
          ]
        });
      }

      allContent.push(...contentArr);
    }

    return {
      content: allContent,
      styles: {
        font9: { fontSize: 9 },
        font8: { fontSize: 8 },
        font10: { fontSize: 10 },
        font11: { fontSize: 11 },
        font12: { fontSize: 12 },
        font13: { fontSize: 13 },
        font14: { fontSize: 14 },
        font16: { fontSize: 16 },
        font17: { fontSize: 17 },
      }
    };
   } catch(error){
console.log(error)
    return {}
   }
  }




  getBase64ImageFromUrl(url: string): Promise<string> {
    console.log(url, 'url')
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      console.log(img.src)
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = error => reject(error);
    });
  }

  toTitleCase(str: string): string {
    return str?.replace(/\w\S*/g, (txt) =>
      txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase()
    );
  }

  toSentenceCase(text: string): string {
    return text
      .toLowerCase()
      .replace(/(^\s*\w|[.!?]\s*\w)/g, (match) => match.toUpperCase());
  }


}
